import PricedropFilledCvna from '@carvana/ds-icons/PricedropFilledCvna';
import GreatDealTag from '@carvana/ds-icons/TagFilledCvna';
import { icon, background } from '@carvana/ds-styles';
import React from 'react';
import TagId from '~/constants/common/TagId';

const getSubText = (
  key: string
): {
  testId?: string;
  Icon?: React.JSX.Element;
  subText: string;
} => {
  switch (key) {
    case 'isFreeDelivery':
      return {
        subText: 'Vehicles without shipping fees and available sooner.',
        testId: 'free-shipping-copy'
      };
    case TagId.GreatDeal.toString():
      return {
        Icon: <GreatDealTag size={16} color={background.medium} />,
        subText:
          'Vehicles priced lower than the Kelley Blue Book® Typical Listing Price.',
        testId: 'great-deal-copy'
      };
    case TagId.PriceDrop.toString():
      return {
        Icon: <PricedropFilledCvna size={16} color={icon.success} />,
        subText:
          'We are always repricing our inventory to make room for new vehicles. Don’t miss out!',
        testId: 'price-drop-copy'
      };
    default:
      return { Icon: <div />, subText: '' };
  }
};

type LabelProps = {
  displayName?: string;
  labelKey: string;
};

export default function GreatDealsLabel({
  displayName = '',
  labelKey
}: LabelProps) {
  const { testId, Icon, subText } = getSubText(labelKey);

  return (
    <div className="grid gap-sm">
      <div className="flex items-center gap-sm">
        {Icon}
        <span className="text-text-strong t-label-sm">{displayName}</span>
      </div>
      <div className="text-text-weak t-body-sm" data-testid={testId}>
        {subText}
      </div>
    </div>
  );
}
